<div *ngIf="viewStatus == ViewStatus.READY">
  <h6 class="title">
    {{ totalReviews == 0 ? ('No Reviews' | translate) : totalReviews == 1 ? ('1 Review' | translate) : (totalReviews + '
    ' + ('Reviews' | translate)) }}
  </h6>

  <div class="row">
    <div *ngFor="let review of reviewData" [ngClass]="showInRows ? 'col-12 col-sm-6  mb-2' : ''">
      <app-review-row [starLabel]="review.label" [count]="review.count" [total]="totalReviews">
      </app-review-row>
    </div>
  </div>
</div>

<ng-container *ngIf="viewStatus == ViewStatus.LOADING">
    <div style="flex: 1 1; width: 100%;">
      <ng-container *ngFor="let i of [1,2]">
        <div class="d-flex flex-row align-items-center justify-content-between gap-2 my-3">
          <div style="width: 100%;" class="d-flex flex-row justify-content-start gap-2">
            <div style="width: 35%;">
              <app-shimmer-loader height="15px" width="100%"></app-shimmer-loader>
            </div>
            <div style="width: 45%;">
              <app-shimmer-loader height="15px" width="100%"></app-shimmer-loader>
            </div>
          </div>
          <div style="width: 8%;">
            <app-shimmer-loader height="15px" width="100%"></app-shimmer-loader>
          </div>
        </div>
        <div class="d-flex flex-row align-items-center justify-content-between gap-2 mb-3">
          <div style="width: 100%;" class="d-flex flex-row justify-content-start gap-2">
            <div style="width: 25%;">
              <app-shimmer-loader height="15px" width="100%"></app-shimmer-loader>
            </div>
            <div style="width: 35%;">
              <app-shimmer-loader height="15px" width="100%"></app-shimmer-loader>
            </div>
          </div>
          <div style="width: 5%;">
            <app-shimmer-loader height="15px" width="100%"></app-shimmer-loader>
          </div>
        </div>
      </ng-container>
      <div class="d-flex flex-row align-items-center justify-content-between gap-2 mb-3">
        <div style="width: 100%;" class="d-flex flex-row justify-content-start gap-2">
          <div style="width: 15%;">
            <app-shimmer-loader height="15px" width="100%"></app-shimmer-loader>
          </div>
          <div style="width: 35%;">
            <app-shimmer-loader height="15px" width="100%"></app-shimmer-loader>
          </div>
        </div>
        <div style="width: 7%;">
          <app-shimmer-loader height="15px" width="100%"></app-shimmer-loader>
        </div>
      </div>
    </div>
</ng-container>